export const MOVIES_LIST_REQUEST = "MOVIES_LIST_REQUEST";
export const MOVIES_LIST_SUCCESS = "MOVIES_LIST_SUCCESS";
export const MOVIES_LIST_FAIL = "MOVIES_LIST_FAIL";

export const MOVIES_RANDOM_REQUEST = "MOVIES_RANDOM_REQUEST";
export const MOVIES_RANDOM_SUCCESS = "MOVIES_RANDOM_SUCCESS";
export const MOVIES_RANDOM_FAIL = "MOVIES_RANDOM_FAIL";

export const MOVIE_DETAILS_REQUEST = "MOVIE_DETAILS_REQUEST";
export const MOVIE_DETAILS_SUCCESS = "MOVIE_DETAILS_SUCCESS";
export const MOVIE_DETAILS_FAIL = "MOVIE_DETAILS_FAIL";
export const MOVIE_DETAILS_RESET = "MOVIE_DETAILS_RESET";

export const MOVIE_TOP_RATED_REQUEST = "MOVIE_TOP_RATED_REQUEST";
export const MOVIE_TOP_RATED_SUCCESS = "MOVIE_TOP_RATED_SUCCESS";
export const MOVIE_TOP_RATED_FAIL = "MOVIE_TOP_RATED_FAIL";

export const CREATE_REVIEW_REQUEST = "CREATE_REVIEW_REQUEST";
export const CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";
export const CREATE_REVIEW_FAIL = "CREATE_REVIEW_FAIL";
export const CREATE_REVIEW_RESET = "CREATE_REVIEW_RESET";

export const DELETE_MOVIE_REQUEST = "DELETE_MOVIE_REQUEST";
export const DELETE_MOVIE_SUCCESS = "DELETE_MOVIE_SUCCESS";
export const DELETE_MOVIE_FAIL = "DELETE_MOVIE_FAIL";

export const DELETE_ALL_MOVIES_REQUEST = "DELETE_ALL_MOVIES_REQUEST";
export const DELETE_ALL_MOVIES_SUCCESS = "DELETE_ALL_MOVIES_SUCCESS";
export const DELETE_ALL_MOVIES_FAIL = "DELETE_ALL_MOVIES_FAIL";

export const CREATE_MOVIE_REQUEST = "CREATE_MOVIE_REQUEST";
export const CREATE_MOVIE_SUCCESS = "CREATE_MOVIE_SUCCESS";
export const CREATE_MOVIE_FAIL = "CREATE_MOVIE_FAIL";
export const CREATE_MOVIE_RESET = "CREATE_MOVIE_RESET";

export const ADD_CAST = "ADD_CAST";
export const EDIT_CAST = "EDIT_CAST";
export const DELETE_CAST = "DELETE_CAST";
export const RESET_CAST = "RESET_CAST";

export const UPDATE_MOVIE_REQUEST = "UPDATE_MOVIE_REQUEST";
export const UPDATE_MOVIE_SUCCESS = "UPDATE_MOVIE_SUCCESS";
export const UPDATE_MOVIE_FAIL = "UPDATE_MOVIE_FAIL";
export const UPDATE_MOVIE_RESET = "UPDATE_MOVIE_RESET";
